import React from 'react';
import { connect } from 'react-redux';

import UserFormCard from './UserFormCard';

import { updateInfo } from '../../../../redux/auth/user/actions';
import { selectFirstName, selectLastName, selectEmail, selectLoading } from '../../../../redux/auth/user/selectors';

const UserFormCardConnected = (props) => <UserFormCard {...props} />;

const mapActionsToProps = {
  updateInfo,
};

const mapStateToProps = (state) => ({
  email: selectEmail(state),
  firstName: selectFirstName(state),
  lastName: selectLastName(state),
  loading: selectLoading(state),
});

export default connect(mapStateToProps, mapActionsToProps)(UserFormCardConnected);
